import st from "@/styles/SignContract.module.scss";
import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import { useTranslation } from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import { useAtom } from "jotai/index";
import {
    contract,
    contract_pg_nr,
    pending_loans,
    sign_contract_otp_interval,
    succeded_application
} from "@/atoms/common.ts";
import useLoans from "@/hooks/loans.ts";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import CMS from "@/utils/cms.ts";
import useAuth from "@/hooks/auth.ts";
import clsx from "clsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {CircularProgress} from "@mui/joy";
import SignContractOTPModal from "@/ui/modals/SignContractOTPModal.tsx";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import useIntervals from "@/hooks/intervals.ts";
import LoanApplicationTypesInterface from "@/types_and_interfaces/loan_types_interface.ts";
import { isMobile } from 'react-device-detect';
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {strings} from "@/utils/strings.ts";
import {schedule_modal_content} from "@/atoms/modals.ts";

import { Document, Page, pdfjs as reactPdfjs } from 'react-pdf';
import * as pdfjsLib from 'pdfjs-dist';
import {ApplicationsAndCrLineStatuses} from "@/types_and_interfaces/enums.ts";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
// import workerUrl from '@/pdf.worker.ts';
reactPdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';
// pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';

const { getDocument } = pdfjsLib;

const SignContract = () => {
    const { t } = useTranslation();
    const [contract_loan, set_contract_loan] = useState<CreditApplicationInterface | LoanInterface | undefined>(undefined);
    const [open_otp_modal_loan, set_open_otp_modal_loan] = useState<CreditApplicationInterface | undefined>(undefined)
    const [pdf_js_success, set_pdf_js_success] = useState(false)
    const navigate = useNavigate();
    const effect_ran = useRef<boolean>(false);
    const loans = useLoans();
    const cr_line_loans = loans.getLoansByType("Credit Line")

    const [applications] = useAtom(pending_loans);
    const [contract_atom] = useAtom(contract);
    const [numPages, setNumPages] = useAtom(contract_pg_nr);
    const containerRef = useRef(null);
    const [scale, set_scale] = useState<number>(1)
    let initialDistance: number | null = null;
    const [sch, set_schedule] = useAtom(schedule_modal_content)
    const [local_sch, set_local_sch] = useState<string>("")
    const [sch_load, set_sch_load] = useState(false)
    const {loan_urn} = useParams()
    const otp_modal_loan_handler = (x:any) => {
        set_open_otp_modal_loan(x)
    }

    const queryParams = new URLSearchParams(location.search);
    const is_cr_line_param = queryParams.get("is_cr_line") || ""

    const handleDownload = () => {
        
        const link = document.createElement('a');
        link.href = contract_atom[contract_loan?.urn || ""].value || "";
        link.download = strings.doc_name.replace("{{urn}}", contract_loan?.urn || "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
    };
    
    const getDistance = (touches:any) => {
        const [touch1, touch2] = touches;
        return Math.sqrt(
            (touch2.clientX - touch1.clientX) ** 2 +
            (touch2.clientY - touch1.clientY) ** 2
        );
    };
    
    const handleTouchStart = (e:any) => {
        if (e.touches.length === 2) {
            initialDistance = getDistance(e.touches);
        }
    };
    
    const handleTouchMove = (e:any) => {
        if (e.touches.length === 2 && initialDistance !== null) {
            const currentDistance = getDistance(e.touches);
            
            if (currentDistance > initialDistance) {
                set_scale((prevScale:number) => Math.min(prevScale + 1, 3));
            } else if (currentDistance < initialDistance) {
                set_scale((prevScale:number) => Math.max(prevScale - 1, 1));
            }
            
            initialDistance = currentDistance;
        }
    };
    
    const open_schedule_handler = async () => {
        if(local_sch.length) {
            set_schedule(local_sch)
            
            return
        }
        
        
        set_sch_load(true)
        if(typeof applications === "object" && Object.keys(applications).length) {
            
            const appl = applications as LoanApplicationTypesInterface
            let to_sign =  undefined
            
            for (const statusKey in appl) {
                const applications = appl[statusKey as ApplicationsAndCrLineStatuses];
                if (Array.isArray(applications)) {
                    const match = applications.find(app => app.urn === loan_urn );
                    if (match) to_sign = match
                }
            }
            
            if(to_sign) {
                const table_html = await loans.get_schedule_html(
                    to_sign.product_id,
                    to_sign.amount,
                    to_sign.nr_of_installments,
                    "0"
                )
                
                if(table_html.length) {
                    set_schedule(table_html)
                    set_local_sch(table_html)
                }
            }
            
            
        }
        set_sch_load(false)
    }
    
    useEffect(() => {
        if(applications === undefined){
            loans.updPendingLoans()
        } else {
            
            let appl = (applications as LoanApplicationTypesInterface)
            
            const applications_by_key = appl.approved_and_need_sign
            
            if (Array.isArray(applications_by_key)) {

                let match = applications_by_key.find(app => app.urn === loan_urn );


                if (match && match.status === "approved_and_need_sign") set_contract_loan(match);
                if (match && match.status !== "approved_and_need_sign") navigate(DashboardClass.dashboard_routes.Home)
            }

            if(!!is_cr_line_param) {
                let match = !!cr_line_loans ? cr_line_loans.find(app => app.urn === loan_urn ) : undefined;

                if(match) set_contract_loan(match);

            }
            
        }
        
        eventEmitter.on(CommonClass.CustomEvents.open_schedule, open_schedule_handler)

        return () => {
            eventEmitter.off(CommonClass.CustomEvents.open_schedule, open_schedule_handler)
        }

    }, [applications, local_sch, cr_line_loans]);
    
    useEffect(() => {
        const getContract = async () => {
            
            await loans.getContract({
                id: contract_loan?.id,
                uid: contract_loan?.urn
            }, contract_loan?.urn || "");
            
            await loans.readContract({
                id: contract_loan?.id,
                uid: contract_loan?.urn
            })
        };

        if(!effect_ran.current && typeof contract_loan === "object" && Object.keys(contract_loan).length && !contract_atom.hasOwnProperty(contract_loan.urn)) {
            getContract();

            effect_ran.current = true
        }
        
    }, [contract_loan]);
    
    useEffect(() => {
        const fetchPdf = async () => {
            if (contract_atom.hasOwnProperty(contract_loan?.urn || "") && contract_atom[contract_loan?.urn || ""]?.value?.length && isMobile && numPages === 0) {
                try {
                    const loadingTask = getDocument(contract_atom[contract_loan?.urn || ""]?.value);
                    const pdf = await loadingTask.promise;
                    setNumPages(pdf._pdfInfo.numPages);
                    
                } catch (err) {
                    console.error('Error loading PDF: ' + err);
                }
            }
        };
        
        fetchPdf();
        
    }, [contract_atom]);
    
    useEffect(() => {
        const container:any = containerRef.current;
        
        if(container){
            container.addEventListener('touchstart', handleTouchStart);
            container.addEventListener('touchmove', handleTouchMove);
        }
        
        return () => {
            
            // set_contract_atom(undefined)
            
            if(container){
                container.removeEventListener('touchstart', handleTouchStart);
                container.removeEventListener('touchmove', handleTouchMove);
            }
        };
    }, []);


    return (

        <>
            <DashboardGenComponent
                light_gray_bg
                responsive1
                center_expanded
                header_type={"primary"}
                onBackClick={() => {is_cr_line_param === ""
                    ? navigate(DashboardClass.dashboard_routes.PendingLoans)
                    : navigate(DashboardClass.dashboard_routes.CreditLine)
                }}
                header_content={
                    <div className={st.header_content}>
                        {t("sign_contract")}
                    </div>
                }
                column_center={
                    <div className={st.column_center}>
                        <div ref={containerRef} className={st.cont}>
                            {
                                (!contract_atom.hasOwnProperty(contract_loan?.urn || "") ||
                                    ( contract_atom.hasOwnProperty(contract_loan?.urn || "") && contract_atom[contract_loan?.urn || ""]?.value?.includes("error"))
                                ) ? (
                                <CircularProgress color={"success"}/>
                            ) : (
                                <>
                                    {isMobile ? (
                                        <>
                                            
                                            {numPages > 0 ? (
                                                <Document
                                                    loading={
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                height: "500px",
                                                                display:"flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            {/*<CircularProgress color={"success"}/>*/}
                                                        </div>
                                                    }
                                                    renderMode={"canvas"}
                                                    className={st.pdf_view}
                                                    file={contract_atom[contract_loan?.urn || ""]?.value}
                                                    onLoadSuccess={() => {
                                                        set_pdf_js_success(true)
                                                    }}
                                                >
                                                    {Array.from({ length: numPages }, (_, index) => (
                                                        <Page
                                                            key={`page_pdf_${index}`}
                                                            width={window.innerWidth - 32}
                                                            className={st.page}
                                                            renderTextLayer={false}
                                                            pageNumber={index + 1}
                                                            scale={scale}
                                                            renderAnnotationLayer={false}
                                                            loading={<></>}
                                                        />
                                                    ))}
                                                
                                                </Document>
                                            ) : <CircularProgress color={"success"}/>}
                                        
                                        </>
                                    ) : (
                                        <iframe
                                            src={contract_atom[contract_loan?.urn || ""]?.value}
                                            title="PDF Viewer"
                                        />
                                    )}
                                </>
                            )}
                        </div>

                        {window.innerWidth <= 1540 && (
                            <div className={st.column_right_mobile}>
                                <Ticks
                                    sign_modal_handler={otp_modal_loan_handler}
                                    dwn={handleDownload}
                                    contract_loan={contract_loan}
                                    pdf_js_success={pdf_js_success}
                                    sch={sch}
                                    open_schedule_handler={open_schedule_handler}
                                    sch_load={sch_load}
                                    is_cr_line={!!is_cr_line_param}
                                />
                                {/*<Button onClick={handleDownload}>Download</Button>*/}
                            </div>
                        )}
                    </div>
                }
                column_right={window.innerWidth > 1540 ? (
                    <div className={st.column_right}>
                        <Ticks
                            contract_loan={contract_loan}
                            sign_modal_handler={otp_modal_loan_handler}
                            dwn={handleDownload}
                            pdf_js_success={pdf_js_success}
                            sch={sch}
                            open_schedule_handler={open_schedule_handler}
                            sch_load={sch_load}
                            is_cr_line={!!is_cr_line_param}
                        />
                        {/*<Button onClick={handleDownload}>Download</Button>*/}
                    </div>
                ) : <></>}
            />
            
            {/*<GetContractModal*/}
            {/*    // line*/}
            {/*    credit={contract_loan}*/}
            {/*    contr={contract_atom}*/}
            {/*/>*/}
            
            <SignContractOTPModal
                data={open_otp_modal_loan}
                data_handler={otp_modal_loan_handler}
                is_cr_line={!!is_cr_line_param}
            />
        </>
    );
};


interface Props {
    dwn():void
    sign_modal_handler(x:any):void
    contract_loan:any
    pdf_js_success: boolean
    sch: any
    open_schedule_handler():void
    sch_load:boolean
    is_cr_line?:boolean
}

const Ticks:React.FC<Props> = (props) => {
    
    const {
        sign_modal_handler,
        contract_loan,
        is_cr_line
        // sch,
        // open_schedule_handler,
        // sch_load
    } = props
    const {t, i18n} = useTranslation()
    const auth = useAuth()
    const user = auth.getProfile()
    const loans = useLoans()
    const agreements = CMS.sign_contract_agreements.list
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [contract_atom] = useAtom(contract);
    const intervals_hook = useIntervals(sign_contract_otp_interval)
    const [, set_succeded_application] = useAtom(succeded_application)

    const sign = async (e: any) => {
        e.preventDefault();

        if(!user?.phone.length) {
            eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true, "", t("add_phone_to_continue"))
            return
        }
        
        const checkboxes = Array.from(document.querySelectorAll('input[type="checkbox"]'));
        const allChecked = checkboxes.every((checkbox: any) => checkbox.checked);
        
        checkboxes.forEach(checkbox => checkbox.classList.remove(st.error));
        
        if (!allChecked) {
            checkboxes.forEach(checkbox => checkbox.classList.add(st.error));
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("sign_err_error"))
            return;
        }
        
        if (typeof contract_loan === "object") {
            setLoading(true)
            
            // @ts-ignore
            if((typeof intervals_hook.getInterval() === "string" && intervals_hook.getInterval().length) || typeof intervals_hook.getInterval() !== "string") {
                sign_modal_handler(contract_loan)
                
            } else {
                
                const data = {
                    id: contract_loan.id,
                    uid: contract_loan.urn,
                    is_credit_line: is_cr_line ? true : undefined
                };
                
                const enabled = await loans.signContractSt1(data);
                
                if(typeof user !== undefined) {
                    if (enabled) {
                        
                        if(user?.auth_type === "ByMPass"){
                            // clear_contract_blob({});
                            set_succeded_application(contract_loan)
                            navigate(DashboardClass.dashboard_routes.Success);
                            
                        } else {
                            intervals_hook.setIntervalHandler()
                            sign_modal_handler(contract_loan)
                            
                        }
                    }
                }
            }
            

            
            setLoading(false)
        }
    };
    
    return (
        <>
            
            <div className={st.agreements}>
                
                <form onSubmit={sign}>
                    
                    {agreements?.map((cont:any, i:number) => {
                        
                        let tempDiv = document.createElement('div');
                        const ct = CMS.langAwareFilter(cont, (i18n.language as LocalLanguage))
                        tempDiv.innerHTML = ct.agreement_content.includes("{{site_url}}") ? ct.agreement_content.replace("{{site_url}}", import.meta.env.VITE_WEBSITE_URL) : ct.agreement_content
                        
                        let links = tempDiv.querySelectorAll('a');
                        links.forEach(link => {
                            link.setAttribute('target', '_blank');
                        });
                        
                        let updatedAgreement = tempDiv.innerHTML;
                        
                        return (
                            <div key={`agreements_checkbox_${i}`} className={st.checkbox_cont}>
                                
                                <input
                                    className={clsx(st.checkbox)}
                                    type={"checkbox"}
                                    // ref={checkbox}
                                    name={`checkbox_${i}`}
                                    defaultChecked={false}
                                    color="success"
                                    onChange={() => {
                                        // if (!checkbox.current) return
                                        // checkbox.current.style.outline = 'none'
                                        // checkbox.current.style.borderRadius = '0'
                                    }}
                                
                                />
                                
                                {ct.agreement_content ? (
                                    <div className={st.content} dangerouslySetInnerHTML={{__html:updatedAgreement}} />
                                ) : null}
                            
                            </div>
                        )
                    })}
                    
                    <Button
                        disabled={loading || !contract_atom.hasOwnProperty(contract_loan?.urn)}
                        type={"submit"}
                        className={st.sign}
                    >
                        
                        {loading && <CircularProgress size={"sm"} color={"success"} />}
                        
                        {t("sign_contract")}
                    
                    </Button>
                
                </form>
            </div>
            
            {/*{isMobile ? (*/}
            {/*    */}
            {/*    <Button*/}
            {/*        type={"button"}*/}
            {/*        onClick={open_schedule_handler}*/}
            {/*        outlined*/}
            {/*        className={st.download_btn}*/}
            {/*        disabled={Boolean(sch) || sch_load}*/}
            {/*    >*/}
            {/*        <>*/}
            {/*            {sch_load && (*/}
            {/*                 <CircularProgress size={"sm"} color={"neutral"}/>*/}
            {/*            )}*/}
            {/*            */}
            {/*            {t("reimbursement_schedule")}*/}
            {/*        </>*/}
            {/*    */}
            {/*    </Button>*/}
            {/*    */}
            {/*) : null}*/}
            
            {/*<div className={st.contract}>*/}
            {/*    */}
            {/*    <strong>*/}
            {/*        {t("contract")}*/}
            {/*    </strong>*/}
            {/*    */}
            {/*    <button*/}
            {/*        onClick={() => {*/}
            {/*            eventEmitter.emit(CommonClass.ModalEvents.OpenGetContractModal, true)*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        {t("download_contract")}*/}
            {/*    </button>*/}
            
            {/*</div>*/}
        </>
    )
}


export default SignContract;
